// extracted by css-extract-rspack-plugin
export default {"root":"ijZM0Gy5cowi42od","inputWrapper":"d7cAONzhzYMdkuPJ","input":"zYmPFIKi_HonUIrM","adornment":"fZ2vDh3pwgin84Me"};